export const API_LINK = process.env.REACT_APP_API_URL;
export const KC_TOKEN = process.env.REACT_APP_TOKEN; //for test purposes
export const KC_URL = process.env.REACT_APP_KC_URL;
export const MODE = process.env.REACT_APP_MODE;
export const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL;
